import Oidc from 'oidc-client';
import { getBasicAuthUrl } from '@/services/helper.service';

export const userManager = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore({
    store: window.localStorage
  }),
  authority: getBasicAuthUrl(),
  client_id: 'my_wires_web_client',
  response_type: 'id_token token',
  scope: 'openid profile main-api',
  redirect_uri: process.env.VUE_APP_AUTH_REDIRECT_URI,
  post_logout_redirect_uri: process.env.VUE_APP_AUTH_POST_LOGOUT_REDIRECT_URI,
  loadUserInfo: true,
  checkSessionInterval: 1000
});

export class AuthControl {
  constructor() {}

  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(err => {
          return reject(err);
        });
    });
  }

  getSignedIn() {
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(function(user) {
          if (user === null) {
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(error => reject(error));
    });
  }

  getUserToken() {
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(user => {
          if (!user) userManager.signinRedirect();
          else return resolve(user.access_token);
        })
        .catch(error => reject(error));
    });
  }

  signOut() {
    userManager
      .getUser()
      .then(user => {
        if (!user) userManager.signoutRedirect();
        else {
          userManager.signoutRedirect({ id_token_hint: user.id_token });
        }
      })
      .catch(error => console.log(error));
  }

  getTermsInfo() {
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(user => {
          if ((user && user.profile.accepted_terms === 'False') || (user && user.profile.accepted_terms == 0)) return resolve(false);
          else return resolve(true);
        })
        .catch(error => console.log(error));
    });
  }

  getExpired() {
    return new Promise(resolve => {
      userManager
        .getUser()
        .then(function(user) {
          if (user !== null) {
            return resolve(user.expired);
          }
        })
        .catch(function() {
          return resolve(true);
        });
    });
  }

  // Returns promise to process response from the authorization endpoint
  // The result of the promise is the authenticated User
  signInRedirectCallback(url) {
    userManager
      .signinRedirectCallback(url)
      .then(function(res) {
        if (res.access_token) {
          window.location.href = '/home';
        }
      })
      .catch(function(err) {
        alert(err);
        window.location.href = '/';
      });
  }
}
